/**
 * 包括専用サイト用の情報
 */
var SpecialCompany = SpecialCompany || {};

/**
 * 包括契約詳細を取得
 *
 * @return Deferred
 */
SpecialCompany.getContractDetails = function() {
	var defer = $.Deferred();
	var ajax = $.ajax({
		url: '/service/contract-details.json',
		method: 'GET',
		success: defer.resolve,
		error: defer.reject
	});

	return defer.promise();
};
